import React from "react";
import SelectPaymentMode from "./SelectPaymentMode";
import ViewFullBreakup from "./viewFullBreakup/ViewFullBreakup";
import CollectedPayments from "./collectedPaymentDetails/CollectedPayments";
import { useGetCollectPaymentContext } from "../context";
import PaymentModeTopStrip from "../alertMessages/PaymentModeTopStrip";
import { useZeroPaidAmountCase } from "../context/customHook";
import FullBreakupDialog from "./viewFullBreakup/FullBreakupDialog";
import { endpoint } from "../../../common/constant";
import { fetchAllPostPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";

const SelectPaymentModeWrapper = ({module}) => {
  const {
    setModifyPaymentModeData,
    modifyPaymentModeData,
    setCurrentPaymentMode,
    currentPaymentMode,
    setPaymentModeForm,
    setBankDropdown,
    studentBasicDetails,
    roleId,
    setBankMasterId,
    balanceMode,
    setPaymentModeIdLimitList,
    bankDropdown,
    paymentModeIdLimitList,
    paymentModeFormHandler,
    paymentModeForm,
    selectedChargesAmount,
    bankMasterId,
    setBalanceMode,
    setBalanceAmount,
    loader,
    setloader,
    setCollectPayment,
    balanceAmount,
    collectPayment,
    isOnlineModeEnabled,
    selectedCharges,
    collectVoucherList,
    vouchersDialogOpen,
    setVouchersDialogOpen,
    availablePosList,
    state,
    setState,
    forCentralizedAdmission,
    validatePaymentMode
  } = useGetCollectPaymentContext(module);

  const getPaymentModeAndVouchersReqObj = () => {
    const { psid, applicationId, bu, businessArea, opportunityOwnerId } = studentBasicDetails;
    return {
      psid,
      applicationId,
      roleId,
      businessArea: bu ?? businessArea,
      opportunityOwnerId,
      examRollNumber: null,
      processType: "Payment Collection",
    }
  }

  const getPaymentModesAndVouchers = async () => {
    const url = endpoint.paymentCollection.getVouchersAndPaymentMode;
    const req = getPaymentModeAndVouchersReqObj();
    return fetchAllPostPromisedData(url, req);
  }

  const contextValue = {
    state,
    setState,
    setModifyPaymentModeData,
    modifyPaymentModeData,
    setCurrentPaymentMode,
    setBankDropdown,
    setPaymentModeForm,
    studentBasicDetails,
    roleId,
    setBankMasterId,
    balanceMode,
    setPaymentModeIdLimitList,
    bankDropdown,
    paymentModeIdLimitList,
    paymentModeFormHandler,
    currentPaymentMode,
    paymentModeForm,
    selectedChargesAmount,
    bankMasterId,
    setBalanceMode,
    setBalanceAmount,
    loader,
    setloader,
    setCollectPayment,
    balanceAmount,
    collectPayment,
    isOnlineModeEnabled,
    selectedCharges,
    collectVoucherList,
    vouchersDialogOpen,
    setVouchersDialogOpen,
    availablePosList,
    forCentralizedAdmission,
    validatePaymentMode,
    // getPaymentModeAndVouchersReqObj
    getPaymentModesAndVouchers
  };

  useZeroPaidAmountCase(
    selectedCharges,
    balanceAmount,
    setCollectPayment,
    collectPayment
  );

  return (
    <>
      <PaymentModeTopStrip module={module} />
      <div className="d-flex mt-2" style={{ columnGap: "10px" }}>
        <SelectPaymentMode contextValue={contextValue} module={module} />
        <div style={{ width: "33%" }}>
          <ViewFullBreakup module={module} FullBreakupDialog={FullBreakupDialog}/>
          <CollectedPayments contextValue={contextValue} module={module} />
        </div>
      </div>
    </>
  );
};

export default SelectPaymentModeWrapper;
